<template>
  <div class="cloud-wrap" :style="cloudWrapStyle">
    <tag-cloud v-if="!isEmptyData" :data="hotTag" @clickTag="clickTagItem" :config="cloudOption"></tag-cloud>
    <!-- 空数据 -->
    <div class="null-data" v-if="isEmptyData">
      <img src="../../../assets/images/img-null-data-light.png" alt="" />
      <p v-if="errorCode" class="textColor">{{ errorCode }}报错</p>
      <p v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import tagCloud from "./tagCloud"
import eventMixin from "utils/event/eventMixin.js"
import { isSsrPage } from "utils"
import parentMixinCommon from "components/bigScreenComponents/common"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, parentMixinCommon, dataRenderMixin],
  name: "cxCloud",
  components: { tagCloud },
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    cloudWrapStyle() {
      return {
        // height: this.height + "px",
        height: "100%",
        "font-style": this.options.fontStyle,
        "font-Family": this.options.fontFamily,
        "font-weight": this.options.fontWeight,
        "text-decoration": this.options.textDecoration,
        transform: "rotate(" + this.options.rotate + "deg)",
        ...this.getChartCommonStyle
      }
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    cloudOption() {
      let radiusSize = Math.min(this.width, this.height)
      console.log("minFontSize",Number(this.options.minFontSize))
      return {
        color: this.options.colorList,
        minFont: Number(this.options.minFontSize),
        maxFont: Number(this.options.maxFontSize),
        radius: Math.floor(radiusSize / 3) - 10,
        wrapperWidth: Math.floor(this.width / 3) - 10,
        wrapperHeight: Math.floor(this.height / 3) - 10,
        rotateAngleXbase: Number(this.options.animateSpeed),
        rotateAngleYbase: Number(this.options.animateSpeed),
        isAnimate: this.options.isAnimate,
        animateRotate: this.options.animateRotate,
        textDirection: this.options.textDirection,
        textDecoration: this.options.textDecoration
      }
    },
    hotTag() {
      let data = []
      let maxDataLen = Math.min(this.options.cloudDatas.length, this.maxCount)
      for (let i = 0; i < maxDataLen; i++) {
        if (this.options.cloudDatas[i].name.trim().length > 0) {
          data.push(this.options.cloudDatas[i])
        }
      }
      return data
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    isEmptyData: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isEmptyData", "isEmptyData", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isEmptyData", false, null)
      }
    },
    errorCode() {
      return this.options && this.options.errorCode
    },
    maxCount(){
      return this.options.maxCount || 50
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      reloadTimer: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
      if (this.noCacheComponent) {
        this.updateData()
        if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
          this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
        }
      }
      this.resetCloud()
    })
  },
  beforeDestroy() {
    clearInterval(this.reloadTimer)
  },
  methods: {
    async updateData() {
      this.updateNormalRect.call(this, datas => {
        let tmpCloudData = []
        if(datas.length>this.maxCount){
          datas = datas.splice(0,this.maxCount)
        }
        datas.forEach(item => {
          const firstKeyName = Object.keys(item)[0]
          if (item[firstKeyName] && item[firstKeyName].hasOwnProperty("value")) {
            tmpCloudData.push({
              name: item[firstKeyName].value,
              link: item.url
            })
          }
        })
        this.cloudDatas = tmpCloudData
        this.$changeOptionsEV(tmpCloudData, "cloudDatas", false, null, this.myid)
        if(tmpCloudData.length === 0){
          this.isEmptyData = true
        }else{
          this.isEmptyData = false
        }
        this.resetCloud()
      })
    },
    clickTagItem(tag) {
      // 预览页面使用
      if (!tag.link) {
        return
      }
      if (this.request_prefix === "bigScreen" && !this.isBigScreenPreview()) {
        return
      }
      if (this.options.open) {
        if (!this.options.hasOwnProperty('openBlankPage') || this.options.openBlankPage) {
          window.open(tag.link, "_blank")
        } else {
          window.location.href = tag.link
        }
      }
    },
    resetCloud() {
      let element = this.$el
      let _this = this
      const robserver = new ResizeObserver(entries => {
        _this.width = _this.$el.offsetWidth
        _this.height = _this.$el.offsetHeight
      })
      robserver.observe(element)
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
